import { LoaderFunctionArgs, redirect } from "react-router";

/**
 * Resolves the marketplace profiles route, choosing a tab when the address does not name one.
 *
 * The redirect happens here rather than from an effect after the page mounts: a page that renders
 * without a tab and then navigates itself is briefly interactive at an address it is about to leave,
 * and a click landing in that window raced the redirect.
 */
export default async function marketplaceProfileLoader(args: LoaderFunctionArgs) {
  const routeParams = args.params;
  if (!routeParams?.pageTab) return redirect("/marketplace/profiles/individual");
  return routeParams;
}
